import { TextField, TextFieldProps } from '@mui/material';

export const StyledTextField = (props: TextFieldProps) => (
  <TextField
    variant="outlined"
    sx={{ borderRadius: 1, flexGrow: 1 }}
    size="small"
    slotProps={{
      input: { sx: { background: 'white' } },
      inputLabel: { shrink: true },
    }}
    {...props}
  />
);
